module.exports = __webpack_public_path__ + "img/delay_7.08337794.svg";